<template>
  <div class="activity-list flex-rs">
    <collect :item="item" v-for="(item,index) in draftlist" :key="index" v-on:invite="invite" v-on:selectdraft="getdraftid" :action="action"></collect>
  </div>
</template>
<script>
  import collect from './collect.vue'
  import App from '../util/comfun'
  export default {
    name: 'list',
    props:{
      scrolltop:{
        type:Number,
        value:0
      },
      action:{
        type:String,
        value:'topath'
      }
    },
    components:{
      collect,
    },
    data () {
      return {
          openid:JSON.parse(localStorage.getItem('userinfo')).openid,
          page:1,
          draftlist:[],
          load:false,
          end:false,
      }
    },
    watch:{
      scrolltop(){
        this.handleScroll();
      }
    },
    methods:{
        getismanage(){
          this.manage=2;
          this.getdraftlist();
          return;
          App.User.GetOperate().then(res=>{
            if(res.code==200){
              if(res.data.isManager){
                this.manage=1;
                console.log('draftlist:',this.manage)
                //this.getalldraftlist();
                this.getdraftlist();
              }else{
                this.manage=2;
                this.getdraftlist();
              }
            }
          }).catch(res=>{
            this.manage=2;
            this.getdraftlist();
          })
          return;
          this.$http({
            url:'https://pfotoo.com?s=App.User.GetOperate'+this.$getsign(),
            params:{
              openid:this.openid,
            },
            method:'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((res)=>{
            console.log(res.body)
            let json=res.body;
            if(json.ret==200){
               if(json.data){
                 this.manage=1;
                 console.log('draftlist:',this.manage)
                 this.getalldraftlist();
               }else{
                 this.manage=2;
                 this.getdraftlist();
               }
            }
          })
         },
      draftFormat(activityList){
          if(activityList.length>0){
            activityList.forEach((v,i)=>{
              let currenttime=Date.parse(new Date())/1000;
              v.id=v.activityId
              v.name=v.activityName
              v.long_term=v.isLongTerm
              v.close_time=v.deadlinesTime
              v.stime=v.startTime
              v.etime=v.endTime
              v.worksCount=v.joinedPeopleCount
              v.imgCount=v.fileCount
              v.status=v.activityStatus==1?0:1
              v.type=App.metaKey(v.type,App.metaTypeHD)

              v.images=v.coverList[0].url
              if(!v.long_term || (v.long_term && v.long_term==0)){
                if(v.close_time){
                  let interval=(Number(v.close_time)-currenttime)/(24*60*60);
                  if(interval>0){
                    v.interval=Math.ceil(interval);
                  }else{
                    v.interval=interval;
                  }
                }
                v.stime=Number(v.stime);
                v.etime=Number(v.etime);
              }
              //v.coverimg=v.images+'?imageView2/4/w/350/h/200'
              if(v.coverList[0].materialType== "VideoMaterialType"){
                v.coverimg=v.images+'?vframe/jpg/offset/1'
              }else{
                v.coverimg=v.images+'?imageMogr2/format/webp/thumbnail/750x/quality/100!/ignore-error/1/crop/750x520'
              }

            })
            if(activityList.length<10){
              this.end=true
            }
            this.draftlist=this.draftlist.concat(activityList);
            if(this.page==1){
              let selectdraftName=sessionStorage.getItem('selectdraftName')
              let selectdraftId=sessionStorage.getItem('selectdraftId')
              if(selectdraftId){
                this.draftlist.some(draft=>{
                  if(draft.id==selectdraftId){
                    selectdraftName=draft.name
                    return true
                  }
                })
              }
              if(!selectdraftName){
                selectdraftId=this.draftlist[0].id
                selectdraftName=this.draftlist[0].name
              }
              this.$emit('getdraftid',{id:selectdraftId,action:'defalut',name:selectdraftName});
            }
          }
      },
        getdraftlist(){
          App.Contribution.GetContributionByOpenid({
            pageIndex:this.page,
            pageSize:10,
          }).then(res=>{
            if(res.code==200){
              this.draftFormat(res.data.activityList)
            }else{
              this.end=true;
            }
            this.load=true;

          })
          return
          this.$http({
            url:'https://pfotoo.com?s=App.Contribution.GetContributionByOpenid'+this.$getsign(),
            params:{
              openid:JSON.parse(localStorage.getItem('userinfo')).openid,
              page:this.page,
              size:10
            },
            method:'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((res)=>{
            console.log(res.body)
            let json=res.body;
            if(res.body.ret==200){
              if(JSON.stringify(json.data)!="{}"){
               json.data.forEach((v,i)=>{
                 let currenttime=Date.parse(new Date())/1000;
                 if(!v.long_term || (v.long_term && v.long_term==0)){
                 	if(v.close_time){
                 		let interval=(Number(v.close_time)-currenttime)/(24*60*60);
                 		if(interval>0){
                 			v.interval=Math.ceil(interval);
                 		}else{
                 			v.interval=interval;
                 		}
                 	}
                 	v.stime=Number(v.stime);
                 	v.etime=Number(v.etime);
                 }
                 v.coverimg=v.images+'?imageView2/4/w/350/h/200'
               })
               if(json.data.length<10){
                 this.end=true
               }
               this.draftlist=this.draftlist.concat(json.data);
               if(this.page==1){
                this.$emit('getdraftid',{id:this.draftlist[0].id,action:'defalut',name:this.draftlist[0].name});
               }

              }else{
                this.end=true;
              }
              this.load=true;
            }
          })
        },
        getalldraftlist(){
          this.$http({
            url:'https://pfotoo.com?s=App.Contribution.GetContributionList'+this.$getsign(),
            params:{
              page:this.page,
              size:10
            },
            method:'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((res)=>{
            console.log(res.body)
            let json=res.body;
            if(res.body.ret==200){
              if(JSON.stringify(json.data)!="{}"){
               json.data.forEach((v,i)=>{
                 let currenttime=Date.parse(new Date())/1000;
                 if(!v.long_term || (v.long_term && v.long_term==0)){
                 	if(v.close_time){
                 		let interval=(Number(v.close_time)-currenttime)/(24*60*60);
                 		if(interval>0){
                 			v.interval=Math.ceil(interval);
                 		}else{
                 			v.interval=interval;
                 		}
                 	}
                 	v.stime=Number(v.stime);
                 	v.etime=Number(v.etime);
                 }
                 v.coverimg=v.images+'?imageView2/4/w/350/h/200'
               })
               if(json.data.length<10){
                 this.end=true
               }
               this.draftlist=this.draftlist.concat(json.data);
               if(this.page==1){
                this.$emit('getdraftid',{id:this.draftlist[0].id,action:'defalut',name:this.draftlist[0].name});
               }
              }else{
                this.end=true;
              }
              this.load=true;
            }
          })
        },
        handleScroll(){
          console.log('rrrr',this.manage)
           let scrollTop =this.scrolltop;
           if(this.draftlist.length>0){
             if($('.activity-single').length>0){
               let lasttop=$('.activity-single').eq(this.draftlist.length-1).offset().top;
               if(scrollTop>=lasttop-window.innerHeight && !this.end && this.load){
                 this.load=false;
                 this.page+=1;
                 // this.manage=1;
                 if(this.manage==1){
                   console.log('quanbu')
                   //this.getalldraftlist();
                   this.getdraftlist();
                 }else{
                   console.log('bbbbb')
                   this.getdraftlist();
                 }

               }
             }

           }
        },
        invite(id){
          console.log(id)
          this.$emit('invite',id);
        },
        getdraftid(obj){
          this.$emit('getdraftid',obj);
        },
    },
    mounted(){
      this.getismanage();
    }
  }
</script>

<style>
  .activity-list {
      padding-top: 25px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/list.vue